module.exports = __webpack_public_path__ + "img/05求职.afddbf2a.jpg";